
import React, { useState, useEffect } from "react";
import { useAPI } from "../Context/MyContext";
import TemplatePreview from "./TemplatePreview";
import toast from "react-hot-toast";
import ContactSelector from "./ContactSelector";
import VariableInput from "../Component/braodcasting/VariableInput";
import CreditBadge from "../Component/CreditBadge";
import { set } from "react-hook-form";


// Main Component
 
const SendTemplateMessage = () => {
  const { getUserWabaIds, getTemplateByWabaId, getPhoneAll, saveCampaign } = useAPI();

  const [wabaIds, setWabaIds] = useState([]);
  const [selectedWabaId, setSelectedWabaId] = useState("");
  const [templates, setTemplates] = useState([]);
  const [selectedTemplate, setSelectedTemplate] = useState(null);
  const [showPreview, setShowPreview] = useState(false);
  const [selectedContacts, setSelectedContacts] = useState([]);
  const [campaignName, setCampaignName] = useState("");
  const [isSaving, setIsSaving] = useState(false);
  const [phoneNumberId, setPhoneNumberId] = useState(false);

  // Simplified variable management
  const [variablesState, setVariablesState] = useState({});
  const [showVariableSection, setShowVariableSection] = useState(false);


  // console.log("wabaIds are:", wabaIds);
  // console.log("phoneNumberId is:", phoneNumberId);
  // Build available attributes
  const getAvailableAttributes = () => {
    const allAttributes = new Set(["name", "phone"]);
    selectedContacts.forEach((contact) => {
      if (contact.attribute && Array.isArray(contact.attribute)) {
        contact.attribute.forEach((attr) => {
          if (attr.key) allAttributes.add(attr.key.toLowerCase());
        });
      }
    });
    return Array.from(allAttributes).sort();
  };

  // Get attribute value from contact
  const getContactAttributeValue = (contact, attributeName) => {
    if (attributeName === "name") return contact.name || "";
    if (attributeName === "phone") return contact.phone || "";
    if (contact.attribute && Array.isArray(contact.attribute)) {
      const attr = contact.attribute.find(
        (a) => a.key && a.key.toLowerCase() === attributeName.toLowerCase()
      );
      return attr?.value || "";
    }
    return "";
  };

  // Fetch WABA IDs (updated for new API response)
  // useEffect(() => {
  //   (async () => {
  //     try {
  //       const res = await getUserWabaIds();

  //       // Handle new structure: res[0].data or res.data
  //       const responseData = Array.isArray(res) ? res[0]?.data : res?.data || [];

  //       if (!Array.isArray(responseData) || responseData.length === 0) {
  //         toast.error("No WhatsApp Business Accounts found");
  //         return;
  //       }

  //       // Map new format to old structure
  //       const details = responseData.map((item) => ({
  //         id: item.waba_id, // business_id is now WABA ID
  //         name: item.verified_name || "Unnamed Business",
  //         phone_number: item.display_phone_number,
  //         account_id: item.phone_number_id,
  //         platform: item.platform_type,
  //         verification_status: item.status,
  //       }));

  //       setWabaIds(details);
  //       // if (details.length > 0) setSelectedWabaId(details[0].id);
  //     } catch (err) {
  //       console.error(err);
  //       toast.error("Failed to fetch WABA accounts");
  //     }
  //   })();
  // }, []);

  useEffect(() => {
    (async () => {
      try {
        const res = await getUserWabaIds();

        const responseData = Array.isArray(res) ? res[0]?.data : res?.data || [];

        if (!Array.isArray(responseData) || responseData.length === 0) {
          toast.error("No WhatsApp Business Accounts found");
          return;
        }

        const details = responseData.map((item) => ({
          id: item.waba_id,
          name: item.verified_name || "Unnamed Business",
          phone_number: item.display_phone_number,
          account_id: item.phone_number_id,
          platform: item.platform_type,
          verification_status: item.status,
        }));

        setWabaIds(details);

        // 🟩 Auto-handle selection
        if (details.length === 1) {
          // only one WABA found, auto select it
          setSelectedWabaId(details[0].id);
          setPhoneNumberId(details[0].account_id);
        } else if (details.length > 1 && !selectedWabaId) {
          // multiple WABAs, you can choose to preselect the first one
          setSelectedWabaId(details[0].id);
          setPhoneNumberId(details[0].account_id);
          // toast.success("Multiple WABAs found — first one auto-selected");
        }
      } catch (err) {
        console.error(err);
        toast.error("Failed to fetch WABA accounts");
      }
    })();
  }, []);


  // Fetch templates whenever WABA changes
  useEffect(() => {
    (async () => {
      if (!selectedWabaId) return;
      try {
        const res = await getTemplateByWabaId(selectedWabaId);
        setTemplates(res?.data || []);
        setSelectedTemplate(null);
        setShowPreview(false);
        resetVariables();


      } catch (err) {
        console.error("Error fetching templates:", err);
        if (err?.response?.data?.message) {
          toast.error(err.response.data.message);
          setTemplates([]);
          setSelectedTemplate(null);
          setShowPreview(false);
          resetVariables();
        } else {
          toast.error("Failed to fetch templates");
        }
      }
    })();
  }, [selectedWabaId]);

  // useEffect(() => {
  //   wabaIds.map((e) => {
  //     if (e.id === selectedWabaId) {
  //       setPhoneNumberId(e.account_id)
  //     }

  //   })
  // }, [selectedWabaId, wabaIds]);


  // Extract template variables

  useEffect(() => {
    if (!selectedWabaId || wabaIds.length === 0) return;
    const matched = wabaIds.find((w) => w.id === selectedWabaId);
    if (matched) setPhoneNumberId(matched.account_id);
  }, [selectedWabaId, wabaIds]);


  const getTemplateVariables = (template) => {
    if (!template) return [];
    const variables = [];

    const headerComp = template.components?.find((c) => c.type === "HEADER");
    if (headerComp?.text) {
      const headerMatches = headerComp.text.match(/{{\s*([^}]+)\s*}}/g) || [];
      headerMatches.forEach((match, idx) => {
        const content = match.replace(/{{\s*|\s*}}/g, "").trim();
        variables.push({
          type: "header",
          index: idx + 1,
          key: "header",
          originalMatch: match,
          content,
          ...getVariableType(content),
        });
      });
    }

    const bodyComps = template.components?.filter((c) => c.type === "BODY") || [];
    bodyComps.forEach((bodyComp) => {
      const bodyMatches = bodyComp.text.match(/{{\s*([^}]+)\s*}}/g) || [];
      bodyMatches.forEach((match, idx) => {
        const content = match.replace(/{{\s*|\s*}}/g, "").trim();
        variables.push({
          type: "body",
          index: idx + 1,
          key: `body${idx + 1}`,
          originalMatch: match,
          content,
          ...getVariableType(content),
        });
      });
    });

    return variables;
  };

  // Variable type detection
  const getVariableType = (content) => {
    const isNumber = /^\d+$/.test(content);
    if (isNumber) {
      return {
        variableType: "numbered",
        label: `Variable {{${content}}}`,
        canBeDynamic: true,
        canBeStatic: true,
      };
    } else {
      const lowerContent = content.toLowerCase();
      return {
        variableType: "named",
        attributeName: lowerContent,
        label: `{{${content}}}`,
        canBeDynamic: true,
        canBeStatic: false,
      };
    }
  };

  const templateVariables = getTemplateVariables(selectedTemplate);
  const hasVariables = templateVariables.length > 0;
  const availableAttributes = getAvailableAttributes();

  const resetVariables = () => {
    setVariablesState({});
    setShowVariableSection(false);
  };

  useEffect(() => {
    if (hasVariables && selectedContacts.length > 0) {
      setShowVariableSection(true);
    }
  }, [templateVariables, selectedContacts]);

  const handleVariableChange = (variableKey, value) => {
    setVariablesState((prev) => ({
      ...prev,
      [variableKey]: value,
    }));
  };

  const handleTemplateSelect = (templateName) => {
    const selected = templates.find((t) => t.name === templateName);
    setSelectedTemplate(selected);
    setShowPreview(!!selected);
    resetVariables();
  };

  const prepareVariablesPayload = () => {
    const payload = {};
    selectedContacts.forEach((contact) => {
      const contactVariables = {};
      templateVariables.forEach((variable) => {
        const variableState = variablesState[variable.key];
        if (!variableState) return;
        let value = "";
        if (variableState.mode === "static") {
          value = variableState.staticValue || "";
        } else {
          value = getContactAttributeValue(contact, variableState.attributeName);
        }
        contactVariables[variable.key] = value;
      });
      payload[contact._id] = contactVariables;
    });
    return payload;
  };

  const getPreviewVariables = () => {
    if (selectedContacts.length === 0) return {};
    const firstContact = selectedContacts[0];
    const previewVars = {};
    templateVariables.forEach((variable) => {
      const variableState = variablesState[variable.key];
      if (!variableState) {
        previewVars[variable.key] = `[Configure ${variable.label}]`;
        return;
      }
      let value = "";
      if (variableState.mode === "static") {
        value = variableState.staticValue || `[Enter ${variable.label}]`;
      } else {
        value =
          getContactAttributeValue(firstContact, variableState.attributeName) ||
          `[No ${variableState.attributeName}]`;
      }
      previewVars[variable.key] = value;
    });
    return previewVars;
  };

  const validateVariables = () => {
    return templateVariables.every((variable) => {
      const variableState = variablesState[variable.key];
      if (!variableState) return false;
      if (variableState.mode === "static") {
        return variableState.staticValue?.trim();
      } else {
        return selectedContacts.some((contact) =>
          getContactAttributeValue(contact, variableState.attributeName).trim()
        );
      }
    });
  };



  const onSubmit = async (e) => {
    e.preventDefault();
    if (!selectedTemplate || !campaignName.trim() || selectedContacts.length === 0) {
      toast.error("Please select a template, enter a campaign name, and choose contacts.");
      return;
    }
    if (hasVariables && !validateVariables()) {
      toast.error("Please configure all template variables properly.");
      return;
    }
    setIsSaving(true);
    try {
      // const res = await getPhoneAll();
      // console.log("first getPhoneAll:", res)
      // console.log("res_ALLL", res)
      // const PHONE_NUMBER_ID = res.data[0].phone_number_id;
      const campaignData = {
        template_name: selectedTemplate.name,
        language: selectedTemplate.language || "en_US",
        campaign_name: campaignName.trim(),
        waba_id: selectedWabaId,
        contacts_ids: selectedContacts.map((c) => c._id),
        PHONE_NUMBER_ID: phoneNumberId,
        variables: prepareVariablesPayload(),
      };
      // console.log("campaignData", campaignData);

      const result = await saveCampaign(campaignData);
      if (result?.success) {
        toast.success(`Campaign created Successfully!`);
        // toast.success(`Campaign  created saved successfully!`);
      }
      setSelectedTemplate(null);
      setShowPreview(false);
      setCampaignName("");
      setSelectedContacts([])
      resetVariables();
      // console.log("✅ Campaign saved successfully:", result);
    } catch (error) {
      console.error("❌ Campaign save failed:", error?.response?.data || error.message);
      // if (error.statusCode === 403 && error.message) {
      //   console.error("Forbidden error details:", error.message);
      //   toast.error(error.message);
      // }

      toast.error(error?.response?.data.message || "Failed to save campaign");
    } finally {
      setIsSaving(false);
    }
  };
  // console.log("selectedContacts:", selectedContacts)
  return (
    <div className="p-10 min-h-screen bg-gray-100">
      <div className="max-w-7xl mx-auto flex gap-10">
        <form
          onSubmit={onSubmit}
          className="bg-[#F4F0EC] rounded-3xl shadow-sm px-8 py-10 w-1/2 flex flex-col gap-6"
          >
          <CreditBadge/>
          {/* WABA ID Selector */}
          <div className="flex flex-col">
            <label className="text-md font-semibold text-[#333] mb-2">
              WhatsApp Business Account
            </label>
            <select
              value={selectedWabaId}
              onChange={(e) => setSelectedWabaId(e.target.value)}
              className="bg-white border border-gray-300 text-gray-700 rounded-xl px-4 py-2 shadow-inner focus:outline-none"
              disabled={isSaving}
            >
              {wabaIds.map((waba, idx) => (
                <option key={idx} value={waba.id}>
                  {waba.name} ({waba.id})
                </option>
              ))}
            </select>
          </div>

          {/* Template selector */}
          <div className="flex flex-col">
            <label className="text-md font-semibold text-[#333] mb-2">Template</label>
            <select
              value={selectedTemplate?.name || ""}
              onChange={(e) => handleTemplateSelect(e.target.value)}
              className="bg-white border border-gray-300 text-gray-700 rounded-xl px-4 py-2 shadow-inner focus:outline-none"
              disabled={isSaving}
            >
              <option value="">-- Select Template --</option>
              {templates
                .filter((t) => t.status === "APPROVED")
                .map((t, idx) => (
                  <option key={idx} value={t.name}>
                    {t.name}
                  </option>
                ))}
            </select>
          </div>

          {/* Campaign name */}
          <div className="flex flex-col w-full">
            <label className="text-sm font-medium text-[#333] mb-1">Campaign Name</label>
            <input
              type="text"
              value={campaignName}
              onChange={(e) => setCampaignName(e.target.value)}
              placeholder="Special Friday Offer"
              className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-green-500 focus:border-green-500 placeholder-gray-400 text-sm"
              disabled={isSaving}
            />
          </div>

          {/* Contact selector */}
          <div>
            <label className="text-md font-semibold">Select Contacts</label>
            <ContactSelector
              selectedContacts={selectedContacts}
              setSelectedContacts={setSelectedContacts}
              disabled={isSaving}
            />
            <div className="text-sm text-gray-500 mt-1">
              Selected: {selectedContacts.length} contacts
            </div>
          </div>

          {/* Variables section */}
          {showVariableSection && hasVariables && selectedContacts.length > 0 && (
            <div className="border-t pt-6 mt-4">
              <div className="flex items-center justify-between mb-4">
                <h3 className="text-lg font-semibold text-[#333]">Template Variables</h3>
                <div className="text-sm text-gray-600">
                  {templateVariables.length} variable
                  {templateVariables.length !== 1 ? "s" : ""} detected
                </div>
              </div>

              <div className="space-y-4">
                {templateVariables.map((variable) => (
                  <VariableInput
                    key={variable.key}
                    variable={variable}
                    availableAttributes={availableAttributes}
                    value={variablesState[variable.key]}
                    onChange={(val) => handleVariableChange(variable.key, val)}
                    selectedContacts={selectedContacts}
                    getContactAttributeValue={getContactAttributeValue}
                    disabled={isSaving}
                  />
                ))}
              </div>
            </div>
          )}

          {/* Save Campaign button */}
          <button
            type="submit"
            disabled={
              !selectedTemplate || !campaignName.trim() || selectedContacts.length === 0 || isSaving
            }
            className="bg-[#00C48C] text-white font-semibold px-6 py-3 rounded-xl hover:bg-[#00b07d] transition-all disabled:bg-gray-400 disabled:cursor-not-allowed mt-6 flex items-center justify-center gap-2"
          >
            {isSaving ? (
              <>
                <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white"></div>
                Saving Campaign...
              </>
            ) : (
              `Save Campaign with ${selectedContacts.length} Contact${selectedContacts.length !== 1 ? "s" : ""
              }`
            )}
          </button>
        </form>

        {/* Template preview */}
        <div className="w-1/2">
          {showPreview && selectedTemplate ? (
            <div className="sticky top-10">
              <TemplatePreview
                selectedTemplate={selectedTemplate}
                onClose={() => setShowPreview(false)}
                variables={getPreviewVariables()}
              />
            </div>
          ) : (
            <div className="text-gray-500 italic text-center p-8 bg-white rounded-lg">
              Select a template to preview it here
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default SendTemplateMessage;
